import $ from "jquery";
import {DataLayer} from "./Layers/DataLayer";
import {Popup} from "./Popups/Popup";
import {FAQSLayer} from "./Layers/FAQSLayer";

export class SmartpriseCustomer extends FAQSLayer {
    public RegisterEvents() {
        for (const element of $(".template").detach().removeClass("template")) {
            const t = $(element);
            DataLayer.templates[t.attr("id")] = t.removeAttr("id")[0].outerHTML;
        }

        $("#log-out").on('click', () => {
            this.client.log_out().done(x => {
                this.url_params.set("page", "login")
                document.location.search = this.url_params.toString();
            });
        });

        DataLayer.meta = $("#meta").detach();
        this.url_params = new URLSearchParams(window.location.search);

        const page = this.GetPage();
        this.BuildLangDropdown();

        if (page === "login")
            this.OnLogin();
        else if (page === "fines_details")
            this.OnFineDetails();
        else if (page === "faq")
            this.OnFAQS();
    }
}

// @ts-ignore
globalThis.smartprise = new SmartpriseCustomer();
// @ts-ignore
globalThis.Popup = Popup;
// @ts-ignore
globalThis.TS$ = $;

// @ts-ignore
$(() => globalThis.smartprise.RegisterEvents());